import { render, staticRenderFns } from "./CheckStats.vue?vue&type=template&id=0c800838&scoped=true&"
import script from "./CheckStats.vue?vue&type=script&lang=js&"
export * from "./CheckStats.vue?vue&type=script&lang=js&"
import style0 from "./CheckStats.vue?vue&type=style&index=0&id=0c800838&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c800838",
  null
  
)

export default component.exports